import { Affix, Alert, Spin } from "antd";
import { useState } from "react";
import { AxiosInstance } from "axios";
import useInterval from "use-interval";

type Props = {
	url: string;
	axiosInstance: AxiosInstance;

	intervalCheck?: number;
};

export default function CheckHealthServer(props: Props) {
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<{ type: "server" | "network"; message: string }>();

	useInterval(
		() => {
			check();
		},
		error ? 5000 : props.intervalCheck ? props.intervalCheck : 10000
	);

	const check = () => {
		console.info("check");
		setIsLoading(true);
		props.axiosInstance
			.get(props.url || "/")
			.then(() => {
				setError(undefined);
				setIsLoading(false);
			})
			.catch(() => {
				setError({
					type: "server",
					message: "Failed connect to the server. Please reload the page.",
				});
				setIsLoading(false);
			});
	};

	if (!error) {
		return <></>;
	}
	return (
		<Affix offsetTop={10}>
			{isLoading && <Spin style={{ position: "absolute", right: 6, top: 6, zIndex: 10 }} />}
			<Alert
				banner
				message={error?.message}
				type="error"
				style={{ textAlign: "center", color: "red" }}
			/>
		</Affix>
	);
}
